/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The request to send a DIDComm message.
 */
export interface DidCommMessageSend {
    /** The identifiers of Credential REST resources (attachment to DIDCOMM Message). */
    credentials?: string[];
    /** Disable transitive closure of connected resources. */
    disableTransitiveClosure?: boolean;
    /** The identifiers of File REST resources (attachment to DIDCOMM Message). */
    files?: string[];
    /**
     * The primary and unique identifier of the resource (inside tenant)
     * according to [RFC 4122](https://www.rfc-editor.org/info/rfc4122).
     */
    keyId: string;
    /** The identifiers of Presentation REST resources (attachment to DIDCOMM Message). */
    presentations?: string[];
    /** The DID according to [3.1 DID Syntax](https://www.w3.org/TR/did-core/#did-syntax) of [Decentralized Identifiers (DIDs) v1.0](https://www.w3.org/TR/did-core). */
    to: string;
}
